<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!--title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px">{{ i18nValues["labelGenerator"] }}</h4>
      </div>

      <!-- body -->
      <div class="grid-body no-border borderBottom">
        <el-form
          v-loading="loading != 0"
          :model="labelBatch"
          ref="formLabelBatch"
          :rules="rules"
        >
          <div class="gridTemplate">
            <!-- LabelBatch State -->
            <el-form-item :label="i18nValues['status']" prop="state">
              <el-input v-model="labelBatch.state" :placeholder= "this.i18nValues['edition']" disabled></el-input>
            </el-form-item>

            <!-- LabelBatch DispatchType -->
            <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType">
              <el-select :disabled="isPrinted"
                v-model="labelBatch.dispatchType"
                :placeholder="i18nValues['dispatchType']"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :selected="options[1]"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <!-- LabelBatch Pallet Dimension -->
            <el-form-item :label="i18nValues['palletDimension']" prop="palletDimension">
              <el-input v-model="labelBatch.palletDimension" :placeholder="i18nValues['palletDimension']" :disabled="isPrinted"></el-input>
            </el-form-item>

            <!-- LabelBatch GrossWeight -->
            <el-form-item :label="i18nValues['grossWeight']" prop="grossWeight">
              <el-input 
                type="number"
                v-model="labelBatch.grossWeight"
                :placeholder="i18nValues['grossWeight']"
                :disabled="!hasBox"
              ></el-input>
            </el-form-item>
          </div>

          <el-form
            v-loading="loading != 0"
            :model="item"
            ref="formItem"
            :rules="rulesItems"
          >
            <div class="gridTemplate" v-if="!isPrinted">
              <!-- Item Product -->
              <el-form-item prop="product" label="Item">
                <el-select
                  v-model="item.product.id"
                  :placeholder="i18nValues['brand-variety']"
                  filterable
                  @change="changeCropAndSilos({ ...item.product })"
                >
                  <el-option
                    v-for="product in ProductList"
                    :key="product.id"
                    :label="`${product.brand} - ${product.name}`"
                    :value="product.id"
                  >
                    <span v-html="`<strong>${product.brand}</strong> - ${product.name}`"></span>
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- Item Batch Prefix -->
              <el-form-item prop="batchPrefix" :label="i18nValues['batchPrefix']">
                <el-input
                  v-model="item.batchPrefix"
                  :placeholder="i18nValues['batchPrefix']"
                ></el-input>
              </el-form-item>

              <!-- Item Batch -->
              <el-form-item prop="batch" :label="i18nValues['batch']">
                <el-input
                  v-model="item.batch"
                  :placeholder="i18nValues['batch']"
                ></el-input>
              </el-form-item>

              <!-- Item Calculate Batch -->
              <el-form-item prop="calculateBatch">
                <el-button
                  @click="calculateBatch()"
                  icon="fas fa-calculator"
                  id="addBatchButton"
                  size="small"
                  type="primary"
                  class="btn-primary"
                  style="margin-top:24px"
                >
                </el-button>
              </el-form-item>

              <!-- Item Bag -->
              <el-form-item :label="i18nValues['bagType']" prop="type">
                <el-select
                  v-model="item.type"
                  :placeholder="i18nValues['bagType']"
                  @change="recomendPoundsPerBag(item.type)"
                >
                  <el-option
                    v-for="b in bolsas"
                    :key="b.value"
                    :label="b.label"
                    :value="b.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <!-- Item CropType -->
              <el-form-item :label="i18nValues['crop']" prop="cropType">
                <el-select disabled
                  v-model="item.cropType"
                  :placeholder="i18nValues['crop']"
                >
                  <el-option
                    v-for="v in variedades"
                    :key="v.value"
                    :label="v.label"
                    :value="v.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <!-- Item Date -->
              <el-form-item :label="i18nValues['creationDate']" prop="date">
                <div class="input-group">
                  <el-date-picker
                    type="date"
                    class="calendar"
                    format="dd/MM/yyyy"
                    v-model="item.date"
                    placeholder="Select date"
                  >
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>
                </div>
              </el-form-item>

              <!-- Item WeightPerBag-->
              <el-form-item :label="i18nValues['weightPerBag']" prop="weightPerBag">
                <el-input
                  type="number"
                  v-model="item.weightPerBag"
                  :placeholder="i18nValues['weightPerBag']" 
                  @input="calculateNetWeight()"
                  @keypress.native="isNumberWithDecimals($event)"
                ></el-input>
              </el-form-item>

              <!-- Item Pounds/Bag -->
              <el-form-item :label="i18nValues['poundsPerBag']" prop="poundsPerBag">
                <el-input
                  v-model="item.poundsPerBag"
                  :placeholder="i18nValues['poundsPerBag']"
                  @keypress.native="isNumber($event)"
                ></el-input>
              </el-form-item>

              <!-- Item BagsNumber -->
              <el-form-item :label="i18nValues['bagsNumber']" prop="bagsNumber">
                <el-input
                  type="number"
                  v-model="item.bagsNumber"
                  :placeholder="i18nValues['bagsNumber']"
                  @input="calculateNetWeight()"
                  @keypress.native="isNumber($event)"
                ></el-input>
              </el-form-item>

              <!-- Item NetWeight -->
              <el-form-item :label="i18nValues['netWeightPerItem']" prop="netWeight">
                <el-input
                  type="number"
                  v-model="item.netWeight"
                  :placeholder="i18nValues['netWeightPerItem']"
                  disabled
                ></el-input>
              </el-form-item>
              
              <!-- Item SeedPerLb -->
              <el-form-item :label="i18nValues['seedPerLb']" prop="seedPerLb">
                <el-input
                  type="number"
                  v-model="item.seedPerLb"
                  :placeholder="i18nValues['seedPerLb']"
                  @input="calculateSPP()"
                  @keypress.native="isNumberWithDecimals($event)"
                ></el-input>
              </el-form-item>

              <!-- Item SeedPerPound -->
              <el-form-item :label="i18nValues['seedsPerPound']" prop="seedsPerPound">
                <el-input
                  type="number"
                  v-model="item.seedsPerPound"
                  :placeholder="i18nValues['seedsPerPound']"
                  disabled
                ></el-input>
              </el-form-item>

              <el-form-item :label="i18nValues['silo']" prop="originSilo.id">
                <el-select 
                  v-model="item.originSilo.id"
                  :placeholder="i18nValues['silo']"
                >
                  <el-option
                    v-for="silo in SilosListFiltered"
                    :key="silo.id"
                    :label="`${silo.name} - ${silo.field.name}`"
                    :value="silo.id"
                  >
                    <span v-html="`<strong>${silo.name}</strong> - ${silo.field.name}`"></span>
                  </el-option>
                </el-select>
              </el-form-item>

            </div>
            <p></p>
            <p></p>
            <div></div>
            <div></div>
            <!-- Add Item-->
            <div>
              <el-button 
                v-if="!isPrinted"
                @click="addItem()"
                icon="fas fa-plus"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["addItem"] }}
              </el-button>
            </div>

            <!-- Table -->
            <el-form-item prop="item">
              <div class="full-width" style="margin:0 auto;padding:20px;">
                <el-table
                  v-if="itemsList.length > 0"
                  :data="itemsList"
                  class="table table-hover table-striped"
                  id="itemsTable"
                  :empty-text="i18nValues['noDataAvailable']"
                  align="center"
                >
                  <!-- Item Name -->
                  <el-table-column
                    prop="product.brand"
                    label="Brand"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item Type-->
                  <el-table-column
                    prop="type"
                    :label="i18nValues['bagType']"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item CropType -->
                  <el-table-column
                    prop="cropType"
                    :label="i18nValues['crop']"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item Batch  -->
                  <el-table-column
                    prop="batch"
                    :label="i18nValues['batch']"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item Date -->
                  <el-table-column
                    prop="date"
                    :label="i18nValues['date']"
                    :formatter="formatDateRow"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item NetWeight -->
                  <el-table-column
                    prop="netWeight"
                    :label="i18nValues['netWeight']"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item Quantity -->
                  <el-table-column
                    prop="bagsNumber"
                    :label="i18nValues['bagsNumber']"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- Item SPP -->
                  <el-table-column
                    prop="seedsPerPound"
                    label="SPP"
                    width="75"
                    align="center"
                  ></el-table-column>

                  <!-- REMOVE -->
                  <el-table-column width="90" align="right" v-if="!isPrinted">
                    <template slot-scope="scope">
                      <el-button 
                        class="text-danger"
                        icon="fas fa-times"
                        size="small"
                        :title="i18nValues['remove']"
                        @click="removeItem(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>

          <div class="gridTemplate">
            <!-- LabelBatch QtyToPrint -->
            <el-form-item :label="i18nValues['qtyToPrint']" prop="qtyToPrint">
              <el-input
                v-model="labelBatch.qtyToPrint"
                :placeholder="i18nValues['qtyToPrint']"
                :disabled="isPrinted"
                type="number"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>

        <!-- CANCEL/PRINT/SAVE -->
        <div class="full-width d-flex justify-content-end mt-2">
          <el-button
            :loading="loading"
            size="small"
            @click="cancel()"
          >
            {{ i18nValues["cancel"] }}
          </el-button>
          <el-button
            v-if="componentsMap.get('labelBatch_print')"
            icon="fas fa-print"
            :loading="loading"
            :disabled="!hasCampaign"
            :title="!hasCampaign ? (i18nValues['campaignRequired'] || 'Select a Campaign first') : ''"
            size="small"
            class="btn-primary"
            @click="print()"
          >
            {{ i18nValues["print"] }}
          </el-button>
          <el-button
            v-if="!isPrinted"
            icon="fas fa-check"
            :loading="loading"
            :disabled="!hasCampaign"
            :title="!hasCampaign ? (i18nValues['campaignRequired'] || 'Select a Campaign first') : ''"
            size="small"
            class="btn-primary"
            @click="save()"
          >
            {{ i18nValues["save"] }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import moment from "moment";
export default {
  name: "LabelEdition",

  created() {
    this.retrieveLabelBatchs();
    this.retrieveSilos();

    this.rules = {
      dispatchType: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      qtyToPrint: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
    };

    this.rulesItems = {
      cropType: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      type: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      product: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      batch: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      batchPrefix: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      netWeight: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      grossWeight: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      bagsNumber: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      date: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      poundsPerBag: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      weightPerBag: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      "originSilo.id": [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.i18nValues["siloRequired"] || "Please select a Silo."));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ]
    };

    this.retrieveProducts();

    if (this.id != 0) {
      this.retrieveById();
    } else {
      this.labelBatch.creationUser = this.user.name;
      this.labelBatch.createdDate = new Date();
    }
    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };
  },

  components: {},

  computed: {
    loading: get("label/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
    hasCampaign() {
      return !!(this.globalCampaign && this.globalCampaign.id);
    },
  },

  props: {
    id: null,
    componentsMap: {},
  },

  data() {
    return {
      label: {
        name: null,
        tipoDeDespacho: null,
        batch: null,
        bagsNumber: null,
        cantidadEtiquetas: null,
        items: [{}],
        cantidadImprimir: 0,
        pallet: {},
      },
      prefix: null,
      rules: {},
      rulesItems: {},
      isPrinted: false,
      printing: false,
      item: {
        batch: null,
        batchPrefix: null,
        type: null,
        product: {},
        originSilo: {},
        poundsPerBag: null,
      },
      labelBatch: {
        state: null,
        grossWeight: 0,
      },
      idToPrint: null,
      dispatchType: null,
      itemsList: [],
      ProductList: [],
      ProductListOG: [],
      options: [
        { value: "plane", label: "Aéreo" },
        { value: "ship", label: "Marítimo" },
      ],
      variedades: [
        { value: "corn", label: "Corn Seed" },
        { value: "soy", label: "Soybean Production" },
        { value: "soyRD", label: "Soybean R&D" },
      ],
      bolsas: [
        { value: "bigBag", label: "Bulk Bag" },
        { value: "bag", label: "Paper Bags" },
        { value: "box", label: "Box" },
      ],
      hasBox: false,
      SilosList: [{}],
      SilosListFiltered: [],
      returnQuery: {},
    };
  },

  methods: {
    retrieveLabelBatchs() {
      let filter = {
        fieldSiteId: this.globalFieldSite.id,
      };
      this.$store.dispatch("label/retrieveLabelBatchs", filter).then((res) => {
        this.LabelBatchList = res;
      });
    },

    save() {
      if (!this.globalCampaign || !this.globalCampaign.id) {
        this.$message({
          message: this.i18nValues["campaignRequired"] || "Please select a Campaign before saving.",
          type: "warning",
        });
        return;
      }
      var repeated = false;
      this.$refs["formLabelBatch"].validate((valid) => {
        if (valid) {
          if (this.itemsList == null || this.itemsList.length == 0) {
            this.$message({
              message: this.i18nValues["errorEmptyItems"],
              type: "warning",
            });
            return;
          }
          for (var a = 0; a < this.itemsList.length; a++) {
            for (var j = 0; j < this.LabelBatchList.length; j++) {
              for (var f = 0; f < this.LabelBatchList[j].items.length; f++) {
                if (this.itemsList[a].batch == this.LabelBatchList[j].items[f].batch) {
                  if (this.itemsList[a].id != this.LabelBatchList[j].items[f].id) {
                    repeated = true;
                  }
                  break;
                }
              }
            }
          }
          this.check();
          this.labelBatch.creationDate = moment().format("YYYY-MM-DD");
          this.labelBatch.items = this.itemsList;
          this.labelBatch.campaign = { id: this.globalCampaign ? this.globalCampaign.id : null };

          for (var i = 0; i < this.labelBatch.items.length; i++) {
            this.checkItem(this.labelBatch.items[i]);
          }
          this.labelBatch.fieldSite = this.globalFieldSite;
          if (repeated == true) {
            this.$confirm(
              "Está seguro que quiere guardar la etiqueta?",
              "La Etiqueta Contiene Lotes Repetidos",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                type: "warning",
              }
            ).then(() => {
              if (this.id == 0) {
                this.addBagWeight(this.labelBatch.items[0]);
              }
              this.$store.dispatch("label/saveLabelBatch", this.labelBatch).then((res) => {
                if (res.status == "OK") {
                  // Update the ID if this was a new label batch
                  if (this.id == 0 && res.statusId) {
                    this.labelBatch.id = res.statusId;
                  }
                  this.$notify({
                    title: this.i18nValues["succes"],
                    message: this.i18nValues["sameBatch"],
                    position: "bottom-right",
                    type: "warning",
                  });
                } else {
                  this.$notify.error({
                    title: this.i18nValues["error"],
                    message: this.i18nValues["labelBatchSavedError"],
                    position: "bottom-right",
                  });
                }
              });
            });
          }

          if (repeated == false) {
            if (this.id == 0) {
              this.addBagWeight(this.labelBatch.items[0]);
            }
            this.labelBatch.campaign = { id: this.globalCampaign ? this.globalCampaign.id : null };
            this.$store.dispatch("label/saveLabelBatch", this.labelBatch).then((res) => {
              if (res.status == "OK") {
                // Update the ID if this was a new label batch
                if (this.id == 0 && res.statusId) {
                  this.labelBatch.id = res.statusId;
                }
                this.$notify.success({
                  title: this.i18nValues["succes"],
                  message: this.i18nValues["labelBatchSaved"],
                  position: "bottom-right",
                });
              }
              if (res.status != "OK") {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["labelBatchSavedError"],
                  position: "bottom-right",
                });
              }
            });
          }
        }
      });
    },

    cancel() {
      this.$router.push({ name: "LabelAdmin", query: this.returnQuery });
    },

    retrieveById() {
      this.$store
        .dispatch("label/retrieveLabelBatchById", { id: this.id })
        .then((res) => {
          this.labelBatch = res;
          this.labelBatch.modificationUser = this.user.name;
          this.labelBatch.modificationDate = new Date();
          if (this.labelBatch.state == "printed" || this.labelBatch.state == "Impreso") {
            this.isPrinted = true;
          }
          this.translate(this.labelBatch);
          this.itemsList = res.items;
          for (var i = 0; i < this.itemsList.length; i++) {
            if (this.itemsList[i].type == "bigBag") {
              this.itemsList[i].type = this.i18nValues["bigBag"];
            }
            if (this.itemsList[i].type == "bag") {
              this.itemsList[i].type = this.i18nValues["bag"];
            }
            if (this.itemsList[i].type == "box") {
              this.itemsList[i].type = this.i18nValues["box"];
              if (this.labelBatch.state == "printed" || this.labelBatch.state == "Impreso") {
                this.hasBox = false;
              } else {
                this.hasBox = true;
              }
            }
            if (this.itemsList[i].cropType == "soy") {
              this.itemsList[i].cropType = this.i18nValues["soy"];
            }
            if (this.itemsList[i].cropType == "corn") {
              this.itemsList[i].cropType = this.i18nValues["corn"];
            }
            if (this.itemsList[i].cropType == "soyRD") {
              this.itemsList[i].cropType = this.i18nValues["soyRD"];
            }
          }
        });
    },

    addItem() {
      this.$refs["formItem"].validate((valid) => {
        if (valid) {
          if (this.item.type == "bigBag") {
            this.item.type = this.i18nValues["bigBag"];
          }
          if (this.item.type == "bag") {
            this.item.type = this.i18nValues["bag"];
          }
          if (this.item.type == "box") {
            this.item.type = this.i18nValues["box"];
          }
          if (this.item.cropType == "soy") {
            this.item.cropType = this.i18nValues["soy"];
          }
          if (this.item.cropType == "soyRD") {
            this.item.cropType = this.i18nValues["soyRD"];
          }
          if (this.item.cropType == "corn") {
            this.item.cropType = this.i18nValues["corn"];
          }
          this.item.netWeight = Math.round(this.item.netWeight * 100) / 100;
          this.item.weightPerBag = Math.round(this.item.weightPerBag * 100) / 100;
          this.item.seedPerLb = Math.round(this.item.seedPerLb * 100) / 100;

          this.itemsList.push(this.item);
          this.addWeight(this.item);

          this.item = {
            product: {},
            originSilo: {},
            batch: null,
            poundsPerBag: null,
            batchPrefix: this.globalFieldSite.batchPrefix,
          };
        }
      });
    },

    addWeight(item) {
      this.labelBatch.grossWeight = item.netWeight + this.labelBatch.grossWeight;
      if (item.type == "box" || item.type == "Box") {
        this.hasBox = true;
      }
    },

    addBagWeight(item) {
      if (item.type == "bigBag" || item.type == "Bulk Bags") {
        this.labelBatch.grossWeight = this.labelBatch.grossWeight + 15;
      }
      if (item.type == "bag" || item.type == "Paper Bags") {
        this.labelBatch.grossWeight = this.labelBatch.grossWeight + 18.5;
      }
    },

    retrieveProducts() {
      this.filter = {};
      this.filter.campaignId = this.globalCampaign ? this.globalCampaign.id : null;
      this.$store.dispatch("product/retrieveProducts", this.filter).then((res) => {
        this.ProductList = res;
      });
    },

    print() {
      if (!this.globalCampaign || !this.globalCampaign.id) {
        this.$message({
          message: this.i18nValues["campaignRequired"] || "Please select a Campaign before printing.",
          type: "warning",
        });
        return;
      }
      var repeated = false;
      this.labelBatch.creationDate = moment().format("YYYY-MM-DD");
      this.labelBatch.printDate = moment().format("YYYY-MM-DD");
      this.check();
      this.$refs["formLabelBatch"].validate((valid) => {
        if (valid) {
          if (this.itemsList == null || this.itemsList.length == 0) {
            this.$message({
              message: this.i18nValues["errorEmptyItems"],
              type: "warning",
            });
            return;
          }
          for (var a = 0; a < this.itemsList.length; a++) {
            for (var j = 0; j < this.LabelBatchList.length; j++) {
              for (var f = 0; f < this.LabelBatchList[j].items.length; f++) {
                if (this.itemsList[a].batch == this.LabelBatchList[j].items[f].batch) {
                  if (this.itemsList[a].id != this.LabelBatchList[j].items[f].id) {
                    repeated = true;
                  }
                  break;
                }
              }
            }
          }
          this.labelBatch.state = "printed";
          this.labelBatch.items = this.itemsList;
          for (var i = 0; i < this.labelBatch.items.length; i++) {
            this.checkItem(this.labelBatch.items[i]);
          }
          this.labelBatch.fieldSite = this.globalFieldSite;
          if (repeated == true) {
            this.$confirm(
              "Está seguro que quiere guardar la etiqueta?",
              "La Etiqueta Contiene Lotes Repetidos",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                type: "warning",
              }
            ).then(() => {
              if (this.id == 0) {
                this.addBagWeight(this.labelBatch.items[0]);
              }
              this.labelBatch.campaign = { id: this.globalCampaign ? this.globalCampaign.id : null };
              this.$store.dispatch("label/saveLabelBatch", this.labelBatch).then((res) => {
                this.labelBatch.id = res.values;
                if (res.status == "OK") {
                  this.$store.dispatch("label/downloadPDF", this.labelBatch.id).then((res) => {
                    if (res.size == 0) {
                      this.$notify.error({
                        title: this.i18nValues["error"],
                        message: this.i18nValues["errorDownload"],
                        position: "bottom-right",
                        duration: 7000,
                      });
                    } else {
                      var blob = new Blob([res], { type: "application/pdf" });
                      const links = document.createElement("a");
                      links.href = URL.createObjectURL(blob);
                      var date = moment().format("YYYYMMDDTHHmmss");
                      links.download = "Placard_" + this.id.toString() + "_" + date;
                      links.click();
                      URL.revokeObjectURL(links.href);
                    }
                    this.$router.push({ name: "LabelAdmin" });
                  });
                  this.$notify.success({
                    title: this.i18nValues["succes"],
                    message: this.i18nValues["sameBatch"],
                    position: "bottom-right",
                    type: "warning",
                  });
                } else {
                  this.$notify.error({
                    title: this.i18nValues["error"],
                    message: this.i18nValues["labelBatchSavedError"],
                    position: "bottom-right",
                  });
                }
              });
            });
          } else {
            if (this.id == 0) {
              this.addBagWeight(this.labelBatch.items[0]);
            }
            this.labelBatch.campaign = { id: this.globalCampaign ? this.globalCampaign.id : null };
            this.$store.dispatch("label/saveLabelBatch", this.labelBatch).then((res) => {
              this.labelBatch.id = res.values;
              if (res.status == "OK") {
                this.$store.dispatch("label/downloadPDF", this.labelBatch.id).then((res) => {
                  if (res.size == 0) {
                    this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["errorDownload"],
                      position: "bottom-right",
                      duration: 7000,
                    });
                  } else {
                    var blob = new Blob([res], { type: "application/pdf" });
                    const links = document.createElement("a");
                    links.href = URL.createObjectURL(blob);
                    var date = moment().format("YYYYMMDDTHHmmss");
                    links.download = "Placard_" + this.id.toString() + "_" + date;
                    links.click();
                    URL.revokeObjectURL(links.href);
                  }
                  this.$router.push({ name: "LabelAdmin", query: this.returnQuery });
                  this.$router.push({ name: "LabelAdmin", query: this.returnQuery });
                });
                this.$notify.success({
                  title: this.i18nValues["succes"],
                  message: this.i18nValues["printSuccess"],
                  position: "bottom-right",
                });
              } else {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["labelBatchSavedError"],
                  position: "bottom-right",
                });
              }
            });
          }
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["labelBatchSavedError"],
            type: "warning",
            position: "bottom-right",
          });
        }
      });
    },

    removeItem(obj) {
      this.itemsList = this.itemsList.filter((item) => item != obj);
      this.labelBatch.grossWeight = this.labelBatch.grossWeight - obj.netWeight;
    },

    formatDateRow(row) {
      return this.formatDate(row.date);
    },

    calculateBatch() {
      let request = {
        batches: "",
        fieldSiteId: this.globalFieldSite ? this.globalFieldSite.id : null,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null,
      };

      for (let i = 0; i < this.itemsList.length; i++) {
        request.batches += this.itemsList[i].batch + ",";
      }

      this.$store.dispatch("label/calculateBatch", request).then((res) => {
        this.item.batchPrefix = this.globalFieldSite.batchPrefix;
        this.item.batch = res.batch;
      });
    },

    translate(item) {
      if (item.dispatchType == "plane") {
        item.dispatchType = this.i18nValues["aerial"];
      }
      if (item.dispatchType == "ship") {
        item.dispatchType = this.i18nValues["maritime"];
      }
      if (item.state == "edition") {
        item.state = this.i18nValues["edition"];
      }
      if (item.state == "printed") {
        item.state = this.i18nValues["printed"];
      }
    },

    check() {
      if (this.labelBatch.state == null) {
        this.labelBatch.state = "edition";
      }
      if (this.labelBatch.state == "Edicion") {
        this.labelBatch.state = "edition";
      }
      if (this.labelBatch.state == "Impreso") {
        this.labelBatch.state = "printed";
      }
      if (this.labelBatch.dispatchType == "Aéreo" || this.labelBatch.dispatchType == "Aerial") {
        this.labelBatch.dispatchType = "plane";
      }
      if (this.labelBatch.dispatchType == "Marítimo" || this.labelBatch.dispatchType == "Maritime") {
        this.labelBatch.dispatchType = "ship";
      }
    },

    checkItem(obj) {
      if (obj.type == "Bulk Bags") {
        obj.type = "bigBag";
      }
      if (obj.type == "Paper Bags") {
        obj.type = "bag";
      }
      if (obj.type == "Box") {
        obj.type = "box";
      }
      if (obj.cropType == "Soybean Production") {
        obj.cropType = "soy";
      }
      if (obj.cropType == "Soybean R&D") {
        obj.cropType = "soyRD";
      }
      if (obj.cropType == "Corn Seed") {
        obj.cropType = "corn";
      }
    },

    changeCropAndSilos(product) {
      this.SilosListFiltered = [];
      this.item.originSilo = {};

      const foundProduct = this.ProductList.find((item) => item.id === product.id);
      if (foundProduct) {
        this.item.cropType = foundProduct.cropType;
        this.item.product = { ...foundProduct };
      }

      this.SilosListFiltered = this.SilosList.filter(
        (silo) => silo.product && silo.product.id === product.id
      );
    },

    calculateNetWeight() {
      this.item.netWeight = this.item.weightPerBag * this.item.bagsNumber;
      Math.round(this.item.netWeight);
    },

    calculateSPP() {
      this.item.seedsPerPound = 453600 / this.item.seedPerLb;
      this.item.seedsPerPound = Math.round(this.item.seedsPerPound);
    },

    recomendPoundsPerBag(bag) {
      this.item.poundsPerBag = 0;
      if (bag === "bag") {
        this.item.poundsPerBag += 50;
      } else if (bag === "bigBag") {
        this.item.poundsPerBag += 2400;
      }
    },

    retrieveSilos() {
      let fieldSiteId = this.globalFieldSite ? this.globalFieldSite.id : null;
      this.$store.dispatch("silo/retrieveSilos", { id: fieldSiteId }).then((res) => {
        this.SilosList = res.filter((silo) => silo.type !== "discard");
      });
    },
  },
};
</script>

<style>
.addBatchButton {
  display: none;
}
</style>
